<div class="orders pagination-order">
  <header
    *ngIf="orderLineDetailsGridListing.length > 5 && !isFromIpSummary"
    class="orders-header d-flex align-items-center justify-content-between has-border py-2 mb-4">
    <h1>Order Lines Details</h1>
    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcel()">Export excel</a>
      </div>
    </div>
  </header>

  <p-table
    #dt
    stripedRows
    [rowHover]="true"
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    scrollHeight="calc(100vh - 310px)"
    [size]="'small'"
    responsiveLayout="scroll"
    [value]="orderLineDetailsGridListing"
    styleClass="p-datatable-customers"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
    [paginator]="orderLineDetailsGridListing.length > 5 && !isFromIpSummary"
    [filterDelay]="0"
    styleClass="table-listing">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th
          style="width: 3rem"
          class="number smcolwidth text-center"
          pSortableColumn="LineNum">
          Line
          <p-sortIcon field="LineNum"></p-sortIcon>
        </th>
        <th class="status text-center">PO#</th>
        <th
          style="max-width: 162px; width: 162px"
          class="name trimmedvendorby20char text-center">
          Vendor
        </th>
        <th
          [ngClass]="{ trimmedby50char: descriptionCharacterCond }"
          class="jname text-center">
          Description
        </th>
        <th class="cust-po text-center">Matched %</th>
        <th class="cust-po text-center">UnMat</th>
        <th class="buyer text-right">Qty</th>
        <th class="inhanddate text-center">Sell</th>
        <th class="date-time text-center">Total Sell</th>
        <th class="subtotal text-center">Net</th>
        <th class="commission text-center">Total Cost</th>
        <th class="gp text-center">GP</th>
        <th class="currency text-center">Com</th>

        <!-- <th class="bconsultant">Ven Invoice</th> -->
        <th class="bconsultant text-center">Ven Inv Date</th>
      </tr>

      <tr>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="PurchId"
              id="PurchId"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'PurchId', 'contains')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-orderLineDetailsGridListing
      let-rowIndex="rowIndex">
      <tr
        class="p-selectable-row"
        [pSelectableRow]="orderLineDetailsGridListing"
        [pSelectableRowIndex]="rowIndex">
        <td class="number col-center">
          <!-- <a class="link"> </a> -->
          {{ orderLineDetailsGridListing?.LineNum }}
        </td>
        <td class="number text-center">
          <a class="link" (click)="OpenPoPdf(orderLineDetailsGridListing)">
            {{ orderLineDetailsGridListing?.PurchId }}</a
          >
        </td>
        <td style="max-width: 162px" class="status trimmedvendorby20char">
          <div
            *ngIf="
              orderLineDetailsGridListing?.Vendor?.length > 19;
              else showUntrimmedVendor
            ">
            <div class="trimmedvendor">
              {{ orderLineDetailsGridListing?.Vendor }}
            </div>
          </div>
          <ng-template #showUntrimmedVendor>
            {{ orderLineDetailsGridListing?.Vendor }}
          </ng-template>
        </td>
        <td
          [ngClass]="{
            'trimmeddescription trimmedby50char': descriptionCharacterCond,
          }"
          class="name">
          {{ descriptionCharacterCount(orderLineDetailsGridListing.Description)
          }}{{ orderLineDetailsGridListing?.Description }}
        </td>

        <td class="currency">
          <span
            class="text-center"
            *ngIf="orderLineDetailsGridListing?.MatchedPercent !== 0">
            <a
              class="link"
              style="color: white; font-weight: bold"
              [style]="
                getStyleOfMatchedPercent(
                  orderLineDetailsGridListing?.MatchedPercent
                )
              "
              (click)="openUrlDialog(orderLineDetailsGridListing?.PurchId)">
              {{
                orderLineDetailsGridListing?.MatchedPercent | number: "1.2-2"
              }}%
            </a>
          </span>

          <span
            class="text-center"
            *ngIf="
              orderLineDetailsGridListing?.MatchedPercent === 0 &&
              orderLineDetailsGridListing?.IsCDIExist === true
            ">
            <a
              class="link"
              style="color: white; font-weight: bold"
              (click)="goToCdi(orderLineDetailsGridListing?.PurchId)"
              [style]="
                getStyleOfMatchedPercent(
                  orderLineDetailsGridListing?.MatchedPercent
                )
              ">
              {{
                orderLineDetailsGridListing?.MatchedPercent | number: "1.2-2"
              }}%
            </a>
          </span>

          <!-- <span class="text-center" style="display: inline-block;width:55px;padding: 0.3rem;" *ngIf="orderLineDetailsGridListing?.MatchedPercent === 0 && orderLineDetailsGridListing?.IsCDIExist === false"  >
          {{ orderLineDetailsGridListing?.MatchedPercent | number: '1.2-2' }}%
        </span> -->
        </td>

        <td class="jname align-right">
          {{ orderLineDetailsGridListing?.UnmatchedQty | number: "0.0-2" }}
        </td>

        <td class="jname align-right">
          {{ orderLineDetailsGridListing?.Qty | number: "0.0-2" }}
        </td>
        <td class="buyer align-right">
          {{
            orderLineDetailsGridListing?.Sell
              | currency: "USD" : "symbol" : "0.3-3"
          }}
        </td>
        <td class="inhandate align-right">
          {{
            orderLineDetailsGridListing?.TotalSell
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="date-time align-right">
          {{
            orderLineDetailsGridListing?.Net
              | currency: "USD" : "symbol" : "0.4-4"
          }}
        </td>
        <td class="subtotal align-right">
          {{
            orderLineDetailsGridListing?.TotalCost
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="commission align-right">
          {{
            orderLineDetailsGridListing?.GP
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <td class="gp align-right">
          {{
            orderLineDetailsGridListing?.Commission
              | currency: "USD" : "symbol" : "0.2-2"
          }}
        </td>
        <!-- <td class="currency align-right">
          {{ orderLineDetailsGridListing?.matched | number: '1.2-2' }}%
        </td> -->

        <ng-template #blankCell> </ng-template>
        <td class="cust-po text-center">
          <span *ngIf="orderLineDetailsGridListing?.venInvDate | hideEmptyDate">
            <a
              class="link"
              (click)="openUrlDialog(orderLineDetailsGridListing?.PurchId)"
              >{{
                orderLineDetailsGridListing?.venInvDate | date: "MM-dd-yyyy"
              }}</a
            >
          </span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="20"
          [ngClass]="{
            orderLineDetailsConsumesMessage: orderLineDetailsConsumesMessage
              .toLowerCase()
              .includes('please wait loading lines'),
          }">
          {{ orderLineDetailsConsumesMessage }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer">
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="align-right">{{ totalSell | currency: "USD" }}</td>
        <td></td>
        <td class="align-right">{{ totalCost | currency: "USD" }}</td>
        <td class="align-right">{{ totalGp | currency: "USD" }}</td>
        <td class="align-right">{{ totalComm | currency: "USD" }}</td>
        <td></td>
      </tr>
    </ng-template>
  </p-table>
</div>

<jni-unmatch-url-dialog
  [displayModal]="unmatchQuantityStatus"
  *ngIf="vendorInvoiceJournalDetail?.length"
  (closeDialogEvent)="closeUrlDialog()"
  [vendorInvoiceJournalDetail]="
    vendorInvoiceJournalDetail
  "></jni-unmatch-url-dialog>

<jni-modal-stacker
  *ngIf="poEmailDisplayModal"
  [displayModal]="poEmailDisplayModal"
  (closeEvent)="closeModalForPoEmail()"
  class="modal-header-sticky">
  <h1 class="panelHeading"></h1>
  <div class="panelBody">
    <jni-po-email
      [poEmailData]="poEmailData"
      (closePOEmailModalEvent)="closeModalForPoEmail()"
      [isModal]="true"
      (closePOEmailModalEvent)="closeModalForPoEmail()"></jni-po-email>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="cdiSummaryDisplayModal"
  [displayModal]="cdiSummaryDisplayModal"
  (closeEvent)="closeModalForCDI()">
  <h1 class="panelHeading">CDI Resolution Summary</h1>
  <div class="panelBody">
    <jni-cdi-resolution-summary
      [CDIResolutionNumber]="CDIResolutionNumber"
      [poNumber]="poNumber"
      [saleOrderId]="saleOrderId"
      [cdiRecId]="recId"
      [isFromIRScreen]="true"
      (closeEvent)="closeModalForCDI()"></jni-cdi-resolution-summary>
  </div>
</jni-modal-stacker>
